import React, { useEffect, useState } from "react";
import InfoCard from "../../components/Common/InfoCard";
import { Grid, Text, InlineStack, Modal } from "@shopify/polaris";
import { GetProductOverview, GetProducts } from "../../services/product";
import useProductsStore from "../../store/product";
import { GetBundles } from "../../services/bundle";
import useBundlesStore from "../../store/bundle";
import styles from "../../styles/layouts/Bundles/Bundles.module.css";
import EmptyState from "../../components/Common/EmptyState";
import ProductTable from "../../components/Products/ProductTable";
import BundleForm from "../../forms/Bundles";
import { GetBoxes } from "../../services/box";
import { GetCategories } from "../../services/category";
import { CreateBundle as CreateSingleBundle } from "../../services/bundle";
import Search from "../../components/Common/Search";

export default function ProductDashboard() {
  const { setBundles } = useBundlesStore();
  const { setProducts, products } = useProductsStore();

  const [showModal, setShowModal] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [productOverview, setProductOverview] = useState([]);
  const [selectedProducts] = useState([]);
  const [boxes, setBoxes] = useState([]);
  const [isSearching, setIsSearching] = useState(false);
  const [searchFailed, setSearchFailed] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");

  const fetchBoxes = async () => {
    const { data } = await GetBoxes();
    if (data.result) {
      setBoxes(data.result);
    }
  };

  const [categories, setCategories] = useState([]);
  const fetchCategories = async () => {
    const { data } = await GetCategories();
    if (data.result) {
      setCategories(data.result);
    }
  };

  const [selectedProduct, setSelectedProduct] = useState(null);

  const capitalizeUnderscoreString = (str) => {
    return str
      .split("_")
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
      .join(" ");
  };

  const handleCloseModal = () => {
    setSelectedProduct(null);
    setShowModal(false);
  };

  const fetchProducts = async (search) => {
    setIsSearching(true);
    setSearchTerm(search);
    setSearchFailed(false);
    const { data } = await GetProducts(search, currentPage);
    if (data?.result && data.result.length) {
      setProducts(data.result);
      setSearchTerm("");
    } else if (data.result && !data.result.length) {
      setSearchFailed(true);
    }

    setIsSearching(false);
  };

  const fetchBundles = async () => {
    const { data } = await GetBundles();
    if (data?.result) {
      setBundles(data.result);
    }
  };

  const handleSubmit = (bundle) => {
    return CreateSingleBundle(bundle);
  };
  const handleList = (product) => {
    // setSelectedProduct(product);
    let currentVariant = {};
    if (product.variants[0]) {
      currentVariant = { ...product.variants[0] };
    }
    const partialBundle = {
      name: product.title,
      description: product.description,
      tags: product.tags,
      inventory: currentVariant.inventoryQuantity,
      coverImage: product.images[0] ? { url: product.images[0]?.src } : null,
      images: product.images.map((img) => {
        return { url: img.src };
      }),
      price: currentVariant.price,
      sku: currentVariant.sku,
      components: [
        {
          product: product,
          variantId: currentVariant.id ?? "",
          dimensions: {
            length: product.length,
            width: product.width,
            weight: product.weight,
            height: product.height,
          },
        },
      ],
    };
    setSelectedProduct(partialBundle);
    setShowModal(true);
  };
  const fetchOverview = async () => {
    try {
      const { data } = await GetProductOverview();
      if (data.result) {
        setProductOverview(
          Object.entries(data.result).map(([key, value]) => {
            return {
              label: capitalizeUnderscoreString(key),
              value,
            };
          })
        );
      }
    } catch (e) {
      console.error(e);
    }
  };
  useEffect(() => {
    fetchProducts();
    fetchBundles();
    fetchBoxes();
    fetchCategories();
    fetchOverview();
  }, [currentPage]);

  const handleProductSelection = (product) => {};

  return (
    <>
      {!products.length ? (
        <EmptyState
          heading={"Oops, Your Shelves Are Empty!"}
          text={
            "It looks like your products are not ready yet, we are fetching them from your shopify store."
          }
          btnName={"Add bundle"}
          redirect={"/bundles/create"}
        />
      ) : (
        <>
          <Text as="h3" variant="headingSm">
            Inventory Overview
          </Text>
          <br />
          <Grid columns={{ xs: 1, sm: 1, md: 12, lg: 12, xl: 12 }} fullWidth>
            {productOverview.map((order) => {
              return (
                <InfoCard
                  columnSpan={{ xs: 4, sm: 4, md: 4, lg: 4, xl: 4 }}
                  label={order.label}
                  value={order.value}
                />
              );
            })}
          </Grid>
          <br />
          <br />
          <InlineStack align="space-between" wrap={false}>
            <InlineStack align="start" gap="10">
              <Text as="h3" variant="headingLg">
                Products
              </Text>
            </InlineStack>
            <div className={styles["flex-space"]}>
              <Search onSearch={fetchProducts} />
            </div>
          </InlineStack>
          <br />
          {searchFailed ? (
            <Text variant="bodyMd">
              No results found for query : {searchTerm}
            </Text>
          ) : (
            ""
          )}
          <br />

          <ProductTable
            products={products}
            setCurrentPage={setCurrentPage}
            currentPage={currentPage}
            setSelectedProducts={handleProductSelection}
            selectedProducts={selectedProducts}
            allowCheck={false}
            handleList={handleList}
          />
          <Modal
            open={showModal}
            onClose={handleCloseModal}
            title="List the product as a bundle"
          >
            <Modal.Section>
              {selectedProduct ? (
                <BundleForm
                  isSearching={isSearching}
                  searchProduct={fetchProducts}
                  onSubmit={handleSubmit}
                  key={"create-bundle"}
                  bundle={selectedProduct}
                  categories={categories}
                  boxes={boxes}
                />
              ) : (
                ""
              )}
            </Modal.Section>
          </Modal>
          <br />
        </>
      )}
    </>
  );
}
